import { LinkButton } from '../../../components/linkButton';

const btnClass = 'home-section-1__button-link-wrapper galeria__action-button';

const DriveButton = ({ text, link }: { text: string; link: string }) => (
    <LinkButton buttonText={text} linkTo={link} target={'_blank'} customClassName={btnClass} />
);

// Dotychczasowe odnośniki do archiwów (Dysk Google) i YouTube — bez zmian treści.
export const ArchiveLinks = () => (
    <section className="galeria__text galeria__archive">
        <p>Archiwum z naszych wypraw jest na platformie <span className="text-weight--superBold">Dysk Google</span>:</p>
        <div className="galeria__buttons-wrapper">
            <DriveButton text="Grecja 2025 1" link="https://drive.google.com/drive/folders/1e1px51p_QgFEdvARZ6DD85AZg7HjGDPk?usp=drive_link" />
            <DriveButton text="Grecja 2025 2" link="https://drive.google.com/drive/folders/18aiVgFmFxa5R6y6zQlXtQeWX_pFdfPrB?usp=drive_link" />
            <DriveButton text="Grecja 2026" link="https://drive.google.com/drive/folders/1eic_vDrsZwCgK-otrqR4KkOi_Y3T0nYa?usp=drive_link" />
        </div>
        <div className="galeria__buttons-wrapper">
            <DriveButton text="Gruzja 2026 1" link="https://drive.google.com/drive/folders/1XGDs9sPIuNGptG9FseNUdTPu-LHSXykO?usp=drive_link" />
            <DriveButton text="Gruzja 2026 2" link="https://drive.google.com/drive/folders/1pbB9WLgRcvdOZH7WpyxC2q5sG4nmYWnM?usp=drive_link" />
        </div>
        <div className="galeria__buttons-wrapper">
            <DriveButton text="Polska 2024" link="https://drive.google.com/drive/folders/1ra0NbjJv8Q9-LcUcIEdXhbfwu5537oF1?usp=drive_link" />
            <DriveButton text="Polska 2025" link="https://drive.google.com/drive/folders/13ZfknI39LwLvOrbJ5uu2u0QRGbuuxAYX?usp=drive_link" />
            <DriveButton text="Polska 2026" link="https://drive.google.com/drive/folders/1d4_A4Zyl01cithunPxRMsJyMqOSBAS6d?usp=sharing" />
        </div>

        <p className="galeria__archive-youtube">Filmy z naszych wypraw są na platformie <span className="text-weight--superBold">YouTube</span>:</p>
        <div className="galeria__buttons-wrapper">
            <DriveButton text="Wideo z wypraw" link="https://youtube.com/playlist?list=PLMhZjG7QvZ5B9ZpzMv8QumPhZYifVC_F1&si=Bri0x9m663h8j4XB" />
        </div>
    </section>
);
